import { useCallback, useMemo, useReducer } from 'react'
import { ConversionReportContext } from './context'
import { reducer, initialState } from './reducer'

function ConversionReportProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)

  const cleanup = useCallback(() => {
    dispatch({ type: 'CONVERSION_REPORT/CLEANUP' })
  }, [])

  const setToken = useCallback((adToken) => {
    dispatch({ type: 'CONVERSION_REPORT/TOKEN/SET', payload: { adToken } })
  }, [])

  const unsetToken = useCallback(() => {
    dispatch({ type: 'CONVERSION_REPORT/TOKEN/UNSET' })
  }, [])

  const setAccountId = useCallback((adAccountId) => {
    dispatch({ type: 'CONVERSION_REPORT/AD_ACCOUNT_ID/SET', payload: { adAccountId } })
  }, [])

  const setPagination = useCallback(
    ({ order, search, current, size }) => {
      const payload = {
        order: order ?? state.page.order,
        search: search ?? state.page.search,
        current: current ?? state.page.current,
        size: size ?? state.page.size,
      }
      dispatch({ type: 'CONVERSION_REPORT/PAGINATION/SET', payload })
    },
    [state.page],
  )

  const setSearch = useCallback((search) => {
    dispatch({ type: 'CONVERSION_REPORT/SEARCH/SET', payload: { search } })
  }, [])

  const setAdsPreview = useCallback((advertisement) => {
    dispatch({ type: 'CONVERSION_REPORT/ADS_PREVIEW/SET', payload: { advertisement } })
  }, [])

  const unsetAdsPreview = useCallback(() => {
    dispatch({ type: 'CONVERSION_REPORT/ADS_PREVIEW/UNSET' })
  }, [])

  const setDate = useCallback((date) => {
    dispatch({ type: 'CONVERSION_REPORT/DATE/SET', payload: { date } })
  })

  const setCampaigns = useCallback((campaigns) => {
    dispatch({ type: 'CONVERSION_REPORT/CAMPAIGNS/SET', payload: { campaigns } })
  })

  const setAds = useCallback((ads) => {
    dispatch({ type: 'CONVERSION_REPORT/ADS/SET', payload: { ads } })
  })

  const setStatuses = useCallback((statuses) => {
    dispatch({ type: 'CONVERSION_REPORT/STATUSES/SET', payload: { statuses } })
  })

  const contextValue = useMemo(
    () => ({
      actions: {
        cleanup,
        setToken,
        unsetToken,
        setAccountId,
        setPagination,
        setSearch,
        setAdsPreview,
        unsetAdsPreview,
        setDate,
        setCampaigns,
        setAds,
        setStatuses,
      },
      state,
    }),
    [
      cleanup,
      setToken,
      unsetToken,
      setAccountId,
      setPagination,
      setSearch,
      setAdsPreview,
      unsetAdsPreview,
      setDate,
      setCampaigns,
      setAds,
      setStatuses,
      state,
    ],
  )

  return <ConversionReportContext.Provider value={contextValue}>{children}</ConversionReportContext.Provider>
}

export default ConversionReportProvider
